module.exports = __webpack_public_path__ + "static/media/nessa-icon.403c354e.png";